import {Toggle} from 'material-ui';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import styled from 'styled-components';

import {DetailMissingInputError} from '../errors/InputErrors';
import {HeadlineH1, HeadlineH2} from '../arkulpa-fec/components/Text';
import {ROLE_SELECT, ROLE_USER, ROLE_ADMIN} from '../constants/userConstants';
import {convertErrors} from '../arkulpa-fec/utils/errorHelper';
import {uploadProfilePicture} from '../helpers/uploadHelper';
import ActionButtonRow from '../arkulpa-fec/components/ActionButtonRow';
import ErrorMessage from '../arkulpa-fec/components/ErrorMessage';
import Select from '../arkulpa-fec/components/Select';
import Selector from '../arkulpa-fec/components/Selector';
import config from '../config';
import filterOutNotDefinedValues from '../arkulpa-fec/utils/filterOutNotDefinedValues';

const TwoColContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const HalfWidth = styled.div`
  width: 50%;
`;

const ImagePicker = styled.input`
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  opacity: 0;
`;

export default class extends Component {
  constructor(props) {
    super(props);
    let user = {};
    if (props.data && props.data.user) {
      user = props.data.user;
    }
    this.state = {
      email: '',
      profileImage: undefined,
      phone: '',
      active: true,
      firstName: '',
      lastName: '',
      password: '',
      role: ROLE_USER,
      changePassword: false,
      projects: [],
      ...filterOutNotDefinedValues(user),
    };
  }

  componentWillReceiveProps = newProps => {
    if (newProps.data.error) {
      const {graphQLErrors} = newProps.data.error || {};
      this.setState({errors: graphQLErrors});
    } else {
      const {user} = newProps.data || {};
      this.setState({errors: [], ...filterOutNotDefinedValues(user)});
    }
  };
  _goBackToList = () => {
    let {length, goBack, replace} = this.props.history;
    if (length > 2) {
      goBack();
    } else {
      replace('/users');
    }
  };

  _renderHeadline = () => {
    if (this.props.register) {
      return <HeadlineH1>Benutzer registrieren</HeadlineH1>;
    } else if (this._isNew()) {
      return <HeadlineH1>Neuer Benutzer</HeadlineH1>;
    } else if (this._isAdmin()) {
      return <HeadlineH1>Benutzer bearbeiten</HeadlineH1>;
    }
    return <HeadlineH1>Meine Daten bearbeiten</HeadlineH1>;
  };

  _isNew = () => !this.state._id;

  _isAdmin = () => this.props.user && this.props.user.role === ROLE_ADMIN;

  _save = () => {
    let {projects, profileImageToUpload, ...state} = filterOutNotDefinedValues(this.state);
    if (this._isNew() && !state.password) {
      this.setState({errors: [DetailMissingInputError('Passwort')]});
      return;
    }
    this.setState({savingStatus: 'Benutzer wird gespeichert...'});
    this.props
      .save({
        ...state,
        projects: projects.map(({_id}) => _id),
      })
      .then(result => {
        if (profileImageToUpload) {
          this.setState({savingStatus: 'Passfoto wird hochgeladen...'});
          let {file} = profileImageToUpload;
          let {registerUser, saveUser, saveUserProfile} = result.data;
          if (saveUser) {
            return uploadProfilePicture(file, this.props.user.token, saveUser._id);
          } else {
            let {token} = registerUser || saveUserProfile;
            return uploadProfilePicture(file, token);
          }
        }
      })
      .then(() => {
        if (profileImageToUpload) {
          this.props.data.refetch();
        }
      })
      .then(() => {
        this.setState({savingStatus: undefined});
        if (this.props.register) {
          this.props.history.replace('/register-success');
        } else {
          this._goBackToList();
        }
      })
      .catch(rawErrors => {
        this.setState({savingStatus: undefined});
        let errors = convertErrors(rawErrors);
        this.setState({errors});
        console.log('there was an error sending the query', errors);
      });
  };

  _handleFileSelection = ({target: {files}}) => {
    let file = files[0];
    let reader = new FileReader();
    reader.onload = ({target: {result}}) => {
      this.setState({profileImageToUpload: {file, src: result}});
    };
    reader.readAsDataURL(file);
  };

  _renderProfileImage() {
    let {profileImageToUpload, profileImage} = this.state;
    if (!(profileImageToUpload || profileImage)) return;
    let src;
    if (profileImageToUpload) {
      src = profileImageToUpload.src;
    } else if (profileImage) {
      src = config.thumbBaseUrl + profileImage.filePath;
    }
    return <img src={src} alt="Passfoto" style={{maxWidth: 150, maxHeight: 100}} />;
  }

  _renderButtons = () => {
    let {savingStatus} = this.state;
    let isSaving = !!savingStatus;
    if (!this.props.register) {
      return (
        <ActionButtonRow>
          {this._isAdmin() ? <FlatButton onClick={this._goBackToList} label="Zurück zur Übersicht" /> : <div />}
          <div>
            {!this._isNew() && <FlatButton onClick={() => this.setState({deleteModalOpen: true})} label="löschen" />}
            {!this._isNew() && (
              <FlatButton onClick={() => this.setState({changePassword: true})} label="Passwort ändern" />
            )}
            <FlatButton
              primary
              onClick={this._save}
              label={isSaving ? savingStatus : 'speichern'}
              disabled={isSaving}
            />
          </div>
        </ActionButtonRow>
      );
    }
    return (
      <ActionButtonRow>
        <FlatButton onClick={() => this.props.history.replace('/login')} label="Zurück zum Login" />
        <div>
          <FlatButton
            primary
            onClick={this._save}
            label={isSaving ? savingStatus : 'Benutzer anlegen'}
            disabled={isSaving}
          />
        </div>
      </ActionButtonRow>
    );
  };

  render() {
    let {email, phone, active, firstName, lastName, password, role, changePassword, projects} = this.state;
    const {
      register,
      data: {allProjects},
    } = this.props;
    let isAdmin = this._isAdmin();
    return (
      <div>
        <ErrorMessage errors={this.state.errors} clearErrors={() => this.setState({errors: []})} />
        {this._renderHeadline()}
        <TwoColContent>
          {(isAdmin || register) && (
            <HalfWidth>
              <TextField
                type="text"
                fullWidth={true}
                floatingLabelText="Email*"
                value={email}
                onChange={({target: {value}}) => this.setState({email: value})}
              />
            </HalfWidth>
          )}
          {isAdmin && (
            <HalfWidth>
              <Toggle
                label={'Benutzer ' + (active ? 'aktiviert' : 'deaktiviert')}
                labelPosition="right"
                toggled={active}
                onToggle={(_, active) => this.setState({active})}
              />
            </HalfWidth>
          )}
        </TwoColContent>
        {isAdmin && (
          <TwoColContent>
            <HalfWidth>
              <Select
                label="Berechtigung"
                items={ROLE_SELECT}
                selectedItem={role}
                changeMethod={role => this.setState({role})}
              />
            </HalfWidth>
          </TwoColContent>
        )}
        <TwoColContent>
          <HalfWidth>
            <TextField
              type="text"
              fullWidth={true}
              floatingLabelText="Vorname*"
              value={firstName}
              onChange={({target: {value}}) =>
                this.setState({
                  firstName: value,
                })
              }
            />
          </HalfWidth>
          <HalfWidth>
            <TextField
              type="text"
              fullWidth={true}
              floatingLabelText="Nachname*"
              value={lastName}
              onChange={({target: {value}}) =>
                this.setState({
                  lastName: value,
                })
              }
            />
          </HalfWidth>
        </TwoColContent>
        <HeadlineH2>Image</HeadlineH2>
        <TwoColContent>
          <HalfWidth>
            <RaisedButton label="Wähle ein Passfoto (JPG, PNG)" labelPosition="before" containerElement="label">
              <ImagePicker type="file" accept=".png,.jpg,.jpeg" onChange={this._handleFileSelection} />
            </RaisedButton>
          </HalfWidth>
          <HalfWidth>{this._renderProfileImage()}</HalfWidth>
        </TwoColContent>
        <HeadlineH2>Kontaktdaten</HeadlineH2>
        <TextField
          type="text"
          fullWidth={true}
          floatingLabelText="Telefonnummer*"
          value={phone}
          onChange={({target: {value}}) =>
            this.setState({
              phone: value,
            })
          }
        />
        {allProjects &&
          allProjects.length > 0 && (
            <div>
              <HeadlineH2>Projekte</HeadlineH2>
              <Selector
                items={allProjects || []}
                multiselect
                selectedItems={projects}
                changeMethod={projects => this.setState({projects})}
                renderItem={({name}) => name}
              />
            </div>
          )}
        {(this._isNew() || changePassword || register) && (
          <div>
            <HeadlineH2 style={{marginBottom: 0}}>Passwort</HeadlineH2>
            <TextField
              type="password"
              fullWidth={true}
              floatingLabelText="Passwort*"
              value={password}
              onChange={({target: {value}}) =>
                this.setState({
                  password: value,
                })
              }
            />
          </div>
        )}
        {this._renderButtons()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UserForm.js